import { render, staticRenderFns } from "./warningList.vue?vue&type=template&id=858e7746&scoped=true&"
import script from "./warningList.vue?vue&type=script&lang=js&"
export * from "./warningList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858e7746",
  null
  
)

export default component.exports